// Exports the "default" icons for usage with module loaders
// Usage:
//   CommonJS:
//     require('hugerte/icons/default')
//   ES2015:
//     import 'hugerte/icons/default'
require('./icons.js');